/** Вид передачи в очереди модуля заметок */
export enum EnumTransferKind {
  UPLOAD = 'upload',
  DOWNLOAD = 'download',
}
